<template>
  <div class="auth__password-reset__container">
    <div class="auth__text auth__separator">Vnesite e-poštni naslov za ponovno pošiljanje potrditvenega sporočila</div>
    <form novalidate @submit.prevent="submit">
      <div>
        <v-field :class="getValidationClass('email')">
          <label>Email</label>
          <v-input v-model="form.email" type="email" @focus="scrollToField" />
          <span class="md-error" v-if="!$v.form.email.required">Vpišite email naslov</span>
          <span class="md-error" v-if="$v.form.email.required && !$v.form.email.email">Neveljaven email naslov</span>
        </v-field>

        <v-button type="submit" :disabled="isLoading">Pošlji</v-button>

        <div class="auth__links">
          <router-link class="auth__link" :to="{ name: 'login_path' }">Nazaj na prijavo.</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import FocusableFieldMixin from '../shared/FocusableFieldMixin'
import ValidationMixin from '../shared/ValidationMixin'
import VButton from 'design-system/VButton.vue'
import VField from 'design-system/VField.vue'
import VInput from 'design-system/VInput.vue'

export default {
  components: { VButton, VField, VInput },
  data () {
    return {
      form: {
        email: null,
      },
    }
  },
  mixins: [FocusableFieldMixin, ValidationMixin],
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('auth', ['reSendConfirmationEmail']),
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.reSendConfirmationEmail(this.form.email)
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import './common';
@import '../common';
</style>
